import React, { useEffect, useRef, useState } from "react";
import Layout from "../../layouts/Layout";
import HeadingWithBtns from "../../Components/Common/HeadingWithBtns";
import { useParams } from "react-router-dom";
import {
  ConfirmationSnackbar,
  ErrorSnackbar,
} from "../../Components/Common/CustomSnackbar";
import { Box, Grid2 } from "@mui/material";
import axiosInstance from "../../utils/config/config";
import { useSelector } from "react-redux";
import SingleVideo from "../../Components/HomePage/SingleVideo";

const Post = () => {
  const { id } = useParams();
  const { userData } = useSelector((state) => state.user);
  const [post, setPost] = useState(null);
  const [errorState, setErrorState] = useState({ error: false, message: "" });
  const [successState, setSuccessState] = useState({
    success: false,
    message: "",
  });
  const videoRefs = useRef([]);
  const [currentPlayingIndex, setCurrentPlayingIndex] = useState(null);

  const handlePlayPause = (index) => {
    videoRefs.current.forEach((video, i) => {
      if (video && i !== index) {
        video.pause();
      }
    });

    if (currentPlayingIndex === index) {
      videoRefs.current[index].pause();
      setCurrentPlayingIndex(null);
    } else {
      videoRefs.current[index].play();
      setCurrentPlayingIndex(index);
    }
  };

  const fetchPost = async () => {
    try {
      const response = await axiosInstance.get(`/post?id=${id}`);
      setPost(response.data.post);
    } catch (err) {
      setErrorState({ error: true, message: "Failed to fetch post" });
    }
  };

  useEffect(() => {
    if (id) {
      fetchPost();
    }
  }, [id]);

  if (!post) return null;

  const isPaid =
    userData?.subscribed?.some((i) => i?.creatorId === post?.creator?.id) ||
    userData?.role === "admin";

  return (
    <Box>
      <Layout>
        <HeadingWithBtns creator={userData} analytics />

        <ErrorSnackbar
          error={errorState.error}
          errorMsg={errorState.message}
          handleCloseError={() => setErrorState({ error: false, message: "" })}
        />
        <ConfirmationSnackbar
          snackbarState={successState.success}
          handleSnackbarClose={() =>
            setSuccessState({ success: false, message: "" })
          }
          text={successState.message}
        />

        <Grid2
          container
          spacing={2}
          sx={{
            pt: 2,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Grid2 item xs={12} sx={{ position: "relative" }}>
            <SingleVideo
              item={post}
              index={0}
              videoRef={(ref) => (videoRefs.current[0] = ref)}
              onPlayPause={() => handlePlayPause(0)}
              isPlaying={currentPlayingIndex === 0}
              smallPlayBtn
              borderRadius
              noCreator
              paid={
                userData.subscribed.some(
                  (i) => i?.creatorId === post?.creator?.id
                ) || userData.role === "admin"
              }
              refreshFunction={fetchPost}
            />
          </Grid2>
        </Grid2>
      </Layout>
    </Box>
  );
};

export default Post;
